import { render, staticRenderFns } from "./AddressContent.vue?vue&type=template&id=4c741058&scoped=true&"
import script from "./AddressContent.vue?vue&type=script&lang=js&"
export * from "./AddressContent.vue?vue&type=script&lang=js&"
import style0 from "./AddressContent.vue?vue&type=style&index=0&id=4c741058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c741058",
  null
  
)

export default component.exports